import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const Container = styled(Box)(() => ({
    display: "flex",
    justifyContent: "center",
    position: "fixed",
    bottom: 0,
    width: "100%"
}));

export const Image = styled('img')(() => ({
    height: "50px",
    cursor: "pointer"
}));

export const ImagesContainer = styled(Box)(() => ({
    display: "flex",
    backgroundColor: "white",
    marginTop: "16px",
    padding: "6px 11px",
    gap: "16px",
    borderTopLeftRadius: "9px",
    borderTopRightRadius: "9px"
}));